/* AISEK — equal-height PDP gallery and buy box.
 * Keeps the purchase panel the exact rendered height of the left gallery on tablet/desktop.
 * On mobile, restores Dawn's natural stacked layout. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 750px)');
  const initialized = new WeakSet();

  function prepare(root) {
    if (initialized.has(root)) return;
    const product = root.querySelector('.product.grid:not(.product--no-media)');
    if (!product) return;

    const galleryColumn = product.querySelector(':scope > .product__media-wrapper');
    const infoColumn = product.querySelector(':scope > .product__info-wrapper');
    const info = infoColumn?.querySelector('.product__info-container');
    if (!galleryColumn || !infoColumn || !info) return;

    initialized.add(root);
    const gallery = galleryColumn.querySelector('media-gallery') || galleryColumn;
    let raf = 0;

    const sync = () => {
      raf = 0;
      if (!root.isConnected) {
        observer?.disconnect();
        return;
      }
      if (!desktop.matches) {
        product.classList.remove('aisek-buybox--matched');
        infoColumn.style.removeProperty('--aisek-gallery-height');
        info.removeAttribute('role');
        info.removeAttribute('aria-label');
        info.removeAttribute('tabindex');
        return;
      }

      const galleryHeight = Math.ceil(galleryColumn.getBoundingClientRect().height);
      if (galleryHeight < 100) return;
      infoColumn.style.setProperty('--aisek-gallery-height', galleryHeight + 'px');
      product.classList.add('aisek-buybox--matched');

      const overflows = info.scrollHeight > info.clientHeight + 3;
      if (overflows) {
        info.setAttribute('tabindex', '0');
        info.setAttribute('role', 'region');
        info.setAttribute('aria-label', 'Product details and purchase options — scroll for more');
      } else {
        info.removeAttribute('tabindex');
        info.removeAttribute('role');
        info.removeAttribute('aria-label');
      }
    };

    const requestSync = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    };

    const observer = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(requestSync)
      : null;
    observer?.observe(gallery);
    galleryColumn.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', requestSync, { once: true });
    });
    galleryColumn.addEventListener('click', requestSync);
    desktop.addEventListener?.('change', requestSync);
    window.addEventListener('resize', requestSync, { passive: true });
    window.addEventListener('load', requestSync, { once: true });
    requestSync();
  }

  function mount(scope = document) {
    if (scope.matches?.('product-info')) prepare(scope);
    scope.querySelectorAll?.('product-info').forEach(prepare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  } else {
    mount();
  }
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
